// Widget Scripts
import renderThemeBackgrounds from './js/widgets/renderThemeBackgrounds.js';
import customTicketBtn from './js/widgets/customTicketBtn.js';
import triggerMainFeature from './js/widgets/mainFeature/triggerMainFeature.js';
import specialEvents from './js/widgets/events-slideshow/specialEvents.js';
import updateSignupModule from './js/widgets/signup/updateSignupModule.js';
import renderButtonsWithBackground from './js/widgets/hotButtons.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

import renderTier4Widgets from './js/widgets/tier4Section/renderTier4Widgets.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  renderThemeBackgrounds();
  customTicketBtn();

  if (globalThis.location.pathname === '/') {
    triggerMainFeature();
    specialEvents();
    renderTier4Widgets();
    updateSignupModule();
    renderButtonsWithBackground();
    scrollerSponsors();
  }
});
